import * as angular from "angular";
import {IController} from "angular";

export class auctionStatusCtrl implements IController {

  status: any;

  private statusColors: any;
  private backColor: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    this.statusColors = {
      Assigned : 'green-800',
      Accepted : 'green-300',
      Waiting : 'blue-300',
      Started : 'blue-A700',
      Expired : 'red-300',
      Canceled : 'grey-600'
    };
    this.backColor = this.statusColors[this.status];
  }

  $onChanges(changes) {
    if (changes.id && !changes.id.isFirstChange()) {
      this.backColor = this.statusColors[this.status];
    }
  }

}

angular
  .module('bringoz.admin.auctions')
  .component('auctionStatus', {
    bindings: {
      status: '<'
    },
    template: require('./auction-status.html').default,
    controller: auctionStatusCtrl
  });
